import React from "react";
import { ZoomIn, Microscope } from "lucide-react";
import img1 from "../assets/gallery-1.jpg";
import img2 from "../assets/gallery-2.jpg";
import img3 from "../assets/gallery-3.jpg";
import img4 from "../assets/Rhode-island.png";
import img5 from "../assets/Lohmann-brown.png";
import img6 from "../assets/Australorp.png";

const Gallery = () => {
  const images = [
    { src: img1, id: "Visual 01"},
    { src: img2, id: "Visual 02"},
    { src: img3, id: "Visual 03"},
    { src: img4, id: "Visual 04"},
    { src: img5, id: "Visual 05"},
    { src: img6, id: "Visual 06"}

  ];

  return (
   
    <section id="gallery" className="relative z-10 w-full min-h-screen bg-[#FDFCF8] pt-32 pb-12 overflow-x-hidden">
      <div className="max-w-7xl mx-auto px-6">
        
        <div className="mb-8">
          <div className="flex items-center gap-2 mb-1">
            <Microscope size={14} className="text-[#D4AF37]" />
            <span className="text-[9px] font-black uppercase tracking-[0.3em] text-gray-400">
              Guru’s Sheep & Goat Research archive
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-[#4B3621] tracking-tighter">
            Technical <span className="text-[#2D5A27]">Gallery.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {images.map((img, index) => (
            <div key={index} className="group bg-white p-2 border border-gray-100 rounded-2xl shadow-sm hover:shadow-lg transition-all duration-500">
              
              <div className="relative overflow-hidden rounded-xl aspect-[3/2] bg-gray-50">
                <img 
                  src={img.src} 
                  alt={img.id} 
                  className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" 
                />
                
                <div className="absolute inset-0 bg-[#4B3621]/40 backdrop-blur-[1px] opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                  <ZoomIn className="text-white" size={24} />
                </div>
              </div>

              <div className="mt-3 flex justify-between items-center px-1 pb-1">
                 <span className="text-[#4B3621] font-black text-[9px] uppercase tracking-tighter italic whitespace-nowrap">
                    {img.id}
                 </span>
                 <div className="h-[1px] flex-grow mx-3 bg-gray-100"></div>
                 <span className="text-[#D4AF37] font-bold text-[8px] uppercase tracking-widest whitespace-nowrap">
                    {img.label}
                 </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;